import * as React from "react";
import { Chip, Tooltip } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { DocumentTypes } from "../documentTypes";
import { getDocTypeLabel } from "../components/DocumentTypesLabel";

type Props = {
    docType: DocumentTypes | string | null | undefined;
    lang?: "pl" | "en";
};

export const DocumentTypeChip: React.FC<Props> = ({ docType, lang = "pl" }) => {
    const theme = useTheme();

    if (!docType) return null;

    const code = docType.toString().trim().toUpperCase() as DocumentTypes;

    const shortLabel = getDocTypeLabel(code, "code", lang);
    const fullLabel = getDocTypeLabel(code, "full", lang);

    // 👇 lekki neutralny kolor niezależny od typu
    const base = theme.palette.text.secondary;

    return (
        <Tooltip title={fullLabel}>
            <Chip
                label={shortLabel}
                size="small"
                sx={{
                    fontWeight: 700,
                    letterSpacing: ".04em",

                    color: base,
                    borderColor: alpha(base, 0.35),
                    backgroundColor: alpha(base, theme.palette.mode === "dark" ? 0.18 : 0.08),

                    height: 20,
                    "& .MuiChip-label": {
                        px: 1,
                    }
                }}
                variant="outlined"
            />
        </Tooltip>
    );
};